<template>
  <div>
    <section class="ch-gw-content" id="home" style="position: relative;" :style="{backgroundImage:'url('+homeTitleInfo.urlImg+')'}">
	  <div style="width: 100%;height: 100%;background-color: black;opacity: 0.5;position: absolute;top: 0px;"></div>
      <div class="container ch-gw-animation" style="position: relative;z-index: 8;"  >
        <div class="row">
          <div class="col-lg-12 gw_bj_height" >
            <div class="ch-gw-content-content" >
              <h1 class="ch-gw-content-title gw_title">
                {{ homeTitleInfo.bigName }}
              </h1>
              <p class="ch-gw-content-desc gw_desc" >
                {{ homeTitleInfo.viceName }}
              </p>
              <ul class="ch-gw-content-buttons" v-if="homeTitleInfo.buttonNameList.length>0">
                <li>
                  <a :href="homeTitleInfo.buttonNameList[0].url != '' && homeTitleInfo.buttonNameList[0].url != null?homeTitleInfo.buttonNameList[0].url:homeTitleInfo.buttonNameList[0].module" rel="nofollow noopener" target="_blank" class="ch-gw-main-btn ch-gw-white-btn">
                    {{ homeTitleInfo.buttonNameList[0].name }}
                  </a> 
                </li>
                <li>
                  <a :href="homeTitleInfo.buttonNameList[1].url != '' && homeTitleInfo.buttonNameList[0].url != null?homeTitleInfo.buttonNameList[1].url:homeTitleInfo.buttonNameList[1].module" rel="nofollow noopener" target="_blank" class="ch-gw-main-btn ch-gw-link-btn" style="color: #fbfbfb;">
                    {{ homeTitleInfo.buttonNameList[1].name }} 
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="features" class="ch-gw-features">
      <div class="container" style="display: flex;flex-direction: row;flex-wrap: wrap;padding: 0.5rem;">
        <div class="row" style="width: 100%;margin: 0 auto;">
          <div style="width: 100%;padding-top: 1rem;padding-bottom: 1rem;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: space-between;">
           <h3>新闻资讯</h3>
          </div>
        </div>
        <div class="gw_news_cont">
          <div id="demo" class="carousel slide gw_news_content" data-ride="carousel" data-interval="5000" >
 
            <!-- 指示符 -->
            <ul class="carousel-indicators" style="bottom: 35%;">
              <li data-target="#demo" :data-slide-to="index"  v-for="(item,index) in newSshuffling" :class="{'active':index == 0}"></li>
            </ul>

            <!-- 轮播图片 -->
            <div class="carousel-inner" style="width: 100%;">
              <div class="carousel-item" style="width: 100%;word-wrap:break-word;" v-for="(item,index) in newSshuffling" :class="{'active':index == 0}">
                <div class="row"  style="width: 100%;margin: 0 auto;height: 43rem;">
                  <a :href="item.newsUrl" style="width: 100%;">
                    <div  style="width: 100%;height: 43rem;display: flex;flex-direction: column;justify-content: space-between;">
                        <div style="width:100%;height: 100%;">
                          <div style="width:100%;background-size: cover; height: 97%;" :style="{backgroundImage: 'url('+item.newsImag+')'}">
                            
                          </div>
                        </div>
                      <div class="ch-gw-feature-content" style="word-wrap:break-word;word-break:break-all;overflow: hidden;background-color: #fbfbfb;padding-top: 1rem;padding-bottom: 1rem;height: 17.65rem;">
                        <h3 class="ch-gw-feature-title" >{{ item.newsName }}</h3>
                        <p  class="ch-gw-feature-desc ch-gw-feature-desc-newline" >
                          {{ item.newsViceName }}
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <!-- 左右切换按钮 -->
            <div style="position: absolute;top: 35%;width: 100%;">
              <a class="carousel-control-prev" href="#demo" data-slide="prev">
                <span class="carousel-control-prev-icon"></span>
              </a>
              <a class="carousel-control-next" href="#demo" data-slide="next">
                <span class="carousel-control-next-icon"></span>
              </a>
            </div>

            </div>
            <div class="gw_news_content gw_news_content_link" >
            <div style="width: 100%;background-image: linear-gradient(to left, #01a2e9 , #65e6f7);margin: 0 auto;">
              <div style="width: 90%;margin: 0 auto;padding-top: 0.7rem;;padding-bottom: 0.7rem;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;align-items: center;">
                <h2 style="text-align: center;font-size: 1.3rem;color: azure;">活动新闻</h2>
                <span><a href="about?id=4" class="ch-gw-feature-link" style="color: azure;">查看更多</a></span>
              </div>
            </div>
            <div style="width: 93%;display: flex;flex-direction: column;justify-content: space-between;padding-bottom: 1rem;margin: 0 auto;" v-for="(item,index) in news" v-if="index<3">
              <a :href="item.newsUrl" style="width:100%">
                <p style="font-size: 1.1rem;white-space:nowrap; overflow:hidden;text-overflow:ellipsis;padding-top: 1.5rem;">{{ item.newsDate }}</p>
                <p style="font-size: 1.2rem;white-space:nowrap; overflow:hidden;text-overflow:ellipsis;padding-top: 1.5rem;color: rgb(0,0,0)">{{ item.newsName }}</p>
                <p style="font-size: 1rem;text-overflow: ellipsis;display: -webkit-box;text-overflow: -o-ellipsis-lastline;line-clamp: 2;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 2;padding-top: 1.5rem;" >
                  {{ item.newsViceName }}
                </p>
                <p style="padding-top: 1.6rem;border-bottom: 1px solid rgba(0, 0, 0, 0.2);"></p>
              </a>
            </div>
            </div>

        </div>
      </div>
    </section>

    <section id="about" class="ch-gw-about"  v-if="screenWidth>=992">
      <div class="container ch-dh">
        <div style="width: 100%;padding-top: 1rem;padding-bottom: 1rem;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: space-between;">
          <h3>产品中心</h3>
          <span><a href="product" class="ch-gw-feature-link">查看更多</a></span>
         </div>
        <div class="row" style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;width: 100%;margin: 0 auto;">
          <div class="col-xl-3 col-lg-3 col-sm-6" style="padding-left: 0px;padding-right: 0px;background-color: rgb(255,255,255);min-width: 30%;max-width: 40%;" v-for="(item,index) in product" v-if="index<3">
            
              <div class="ch-gw-feature" >
                <a :href="'product?name='+item.productName" style="width: 100%;">
                    <div  style="width:100%;height: 100%;margin-bottom: 25px;margin-top: 25px;text-align: center;margin: 0 auto;overflow: hidden;" >
                      <div class="product-img" style="width:100%;height: 100%;" >
                        <el-image
                          style="width: 100%; height: 100%"
                          :src="item.productImag"
                          fit="fill">
                        </el-image>
                      </div>
                    </div>
                <div class="ch-gw-feature-content" style="padding-top: 1rem;padding-left: 1rem;padding-right: 1rem;">
                  <div style="width: 100%;height: 10rem;">
                    <p style="font-size: 1.7rem;white-space:nowrap; overflow:hidden;text-overflow:ellipsis;padding-top: 1rem;padding-bottom: 1rem;color: rgb(0,0,0);font-weight: 700;">{{ item.productName }}</p>
                    <p class="ch-gw-feature-desc" style="line-height:1.7rem;word-break: break-all;text-overflow: ellipsis;display: -webkit-box;text-overflow: -o-ellipsis-lastline;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 3;line-clamp: 3;">
                      {{ item.productViceName }}
                    </p>
                  </div>
                  <p style="font-size: 1rem;padding-top: 0.7rem;color: #0baef3;">点击查看</p>
                </div>
                </a>
              </div>
          </div>
        </div>
      </div>
    </section>
    <section id="about" class="ch-gw-about"  v-if="screenWidth<=991">
      <div class="container ch-dh" style="padding: 0.5rem;">
        <div style="width: 100%;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: space-between;">
          <h3>产品中心</h3>
          <span><a href="product" class="ch-gw-feature-link">查看更多</a></span>
         </div>
        <div  style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
          <div class="col-xl-3 col-lg-3 col-sm-6" style="margin-top: 1rem;padding-left: 0px;padding-right: 0px;background-color: rgb(255,255,255);width: 49%;" v-for="(item,index) in product" v-if="index<4">
            
              <div class="ch-gw-feature" style="margin-bottom: 0.5rem;">
                <a :href="'product?name='+item.productName" style="width: 100%;">
                    <div  style="width:100%;height: 100%;margin-bottom: 25px;margin-top: 25px;text-align: center;margin: 0 auto;overflow: hidden;" >
                      <div class="product-img" style="width:100%;height: 100%;" >
                        <el-image
                          style="width: 100%; height: 100%"
                          :src="item.productImag"
                          fit="fill">
                        </el-image>
                      </div>
                    </div>
                <div class="ch-gw-feature-content" style="padding-top: 0.5rem;padding-left: 0.5rem;padding-right: 0.5rem;">
                  <div style="width: 100%;height: 7rem;">
                    <p style="font-size: 1.3rem;white-space:nowrap; overflow:hidden;text-overflow:ellipsis;padding-top: 0.5rem;padding-bottom: 0.5rem;color: rgb(0,0,0);font-weight: 700;">{{ item.productName }}</p>
                    <p class="ch-gw-feature-desc" style="line-height:1.7rem;word-break: break-all;text-overflow: ellipsis;display: -webkit-box;text-overflow: -o-ellipsis-lastline;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 2;line-clamp: 2;">
                      {{ item.productViceName }}
                    </p>
                  </div>
                  <p style="font-size: 0.8rem;padding-bottom: 0.2rem;color: #0baef3;">点击查看</p>
                </div>
                </a>
              </div>
          </div>
        </div>
      </div>
    </section>

    <section id="pricing" class="ch-gw-pricing" v-if="screenWidth>=992">
      <div class="container ch-dh">
      <div style="width: 100%;padding-top: 1rem;padding-bottom: 1rem;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: space-between;">
        <h3>科研支持</h3>
        <span><a href="javascript:void(0)" class="ch-gw-feature-link"></a></span>
       </div>
      <div class="row" style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
        <div class="col-xl-3 col-lg-3 col-sm-6" style="background-color: rgb(255,255,255);min-width: 30%;max-width: 40%;" v-for="(item,index) in support" v-if="index<3">
          <div class="ch-gw-feature">
            <div  style="width:100%;height: 100%;margin-bottom: 0px;margin-top: 25px;text-align: center;margin: 0 auto;overflow: hidden;" >
              <div class="product-img" style="width:100%;height: 100%;" >
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.supportImag"
                  fit="fill">
                </el-image>
              </div>
            </div>
            <!-- style="background-color: #0052D9;height: 20rem;" -->
            <div class="ch-gw-feature-content ch-gw-feature-content-ky" >
              
              <a :href="item.supportUrl" class="ch-gw-feature-link" style="width: 100%;position: relative;z-index: 2;">
                <div style="width: 100%;margin: 0 auto;">
                  <p style="font-size: 1.6rem;">{{ item.supportName }}</p>
                  <p style="font-size: 1rem;padding-top: 1.5rem;min-height: 8rem;line-height:1.7rem;word-break: break-all;text-overflow: ellipsis;display: -webkit-box;text-overflow: -o-ellipsis-lastline;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 4;line-clamp: 4;">
                    {{ item.supportViceName }}
                  </p>
                  <p class="ch-gw-feature-content-xq">点击查看</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      </div>
    </section>

    <section id="pricing" class="ch-gw-pricing" v-if="screenWidth<=991">
      <div class="container ch-dh" style="padding: 0.5rem;">
      <div style="width: 100%;display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: space-between;">
        <h3>科研支持</h3>
        <span><a href="javascript:void(0)" class="ch-gw-feature-link"></a></span>
       </div>
      <div style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
        <div class="col-xl-3 col-lg-3 col-sm-6" style="margin-top: 1rem;padding-left: 0px;padding-right: 0px;background-color: rgb(255,255,255);width: 49%;" v-for="(item,index) in support" v-if="index<4">
          <div class="ch-gw-feature" style="margin-bottom: 0.5rem;">
            <div  style="width:100%;height: 100%;margin-bottom: 25px;margin-top: 25px;text-align: center;margin: 0 auto;overflow: hidden;" >
              <div class="product-img" style="width:100%;height: 100%;">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.supportImag"
                  fit="fill">
                </el-image>
              </div>
            </div>
            <!-- style="background-color: #0052D9;height: 20rem;" -->
            <div class="ch-gw-feature-content ch-gw-feature-content-ky" >
              
              <a :href="item.supportUrl" class="ch-gw-feature-link" style="width: 100%;position: relative;z-index: 2;">
                <div style="width: 100%;height: 7rem;">
                  <p style="font-size: 1.3rem;white-space:nowrap; overflow:hidden;text-overflow:ellipsis;padding-top: 1rem;padding-bottom: 1rem;color: rgb(0,0,0);font-weight: 700;">{{ item.supportName }}</p>
                  <p style="line-height:1.7rem;height: 3.5rem;word-break: break-all;text-overflow: ellipsis;display: -webkit-box;text-overflow: -o-ellipsis-lastline;-webkit-box-orient: vertical; overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp: 2;line-clamp: 2;">
                    {{ item.supportViceName }}
                  </p>
                  <p style="font-size: 0.8rem;padding-top: 0.2rem;padding-bottom: 0.5rem;color: #0baef3;">点击查看</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      </div>
    </section>
  

    
    

  </div>
</template>

<script>
import {queryHomeTitleInfo,queryNews,queryProduct,querySupport } from "@/utils/gw";
export default {
    name: 'index',
    components:{
    
    },
    data() {
      return {
        homeTitleInfo:{buttonNameList:[],bigName:'',viceName:''},
        newSshuffling:[],
        news:[],
        product:[],
        support:[],
        pageIndex:1,
      };
    },
    props:['screenWidth'],
    watch: {
      screenWidth: function (val) {       
              console.log(val);   // 接收父组件的值
          }
    },
    mounted() {
      this.queryHomeTitleInfo();
      this.queryNews();
      this.queryProduct();
      this.querySupport();
    },
    methods: {
      querySupport(){
        querySupport().then((e)=>{
            this.support = e.data.support
        })
      },
      queryProduct(){
        var u = "?pageIndex="+this.pageIndex
        queryProduct(u).then((e)=>{
            this.product = e.data.product
        })
      },
      queryNews(){
        queryNews().then((e)=>{
          this.news = e.data.news
          e.data.news.forEach((e)=>{
            if(e.newsShufflingSwitch == 1){
              this.newSshuffling.push(e)
            }
          })
        })
      },
      queryHomeTitleInfo(){
        queryHomeTitleInfo().then((e)=>{
          e.data.homeTitleInfo[0].urlImg = e.data.homeTitleInfo[0].urlImg
          this.homeTitleInfo = e.data.homeTitleInfo[0]
          console.log(this.homeTitleInfo)
        })
      },
    }
  }
</script>
<style>
  .ch-gw-features{
    padding-top: 80px;
  }
  .ch-gw-about{
    padding-top: 80px;
  }
  .ch-gw-feature-content-ky:hover{
    background-color:#2FC1EF;
    transition: 0.6s; 
    color: rgb(255, 255, 255);
  }
  .ch-gw-feature-content-ky .ch-gw-feature-link  .ch-gw-feature-content-xq{
    font-size: 1rem;padding-top: 1rem;color: #0baef3;
  }
  .ch-gw-feature-content-ky:hover .ch-gw-feature-link .ch-gw-feature-content-xq{
    transition: 0.6s; 
    color: rgb(255, 255, 255) ;
  }

  .ch-gw-feature-content-ky a div p{
    transition: 0.6s; 
    color: rgb(0,0,0);
  }

  .ch-gw-feature-content-ky:hover a div p{
    transition: 0.6s; 
    color: rgb(255, 255, 255);
  }

  .ch-gw-feature-content-ky a div i{
    transition: 0.6s; 
    color: rgb(0,0,0);
  }

  .ch-gw-feature-content-ky:hover a div i{
    transition: 0.6s; 
    color: rgb(255, 255, 255);
  }
  .ch-gw-feature .ch-gw-feature-desc{
    margin-bottom: 20px;
  }
  .ch-gw-feature-title {
    height: 3em;
    line-height: 1.4em;
    overflow: hidden;
    width: 95%;
    margin: 0 auto;
    /* 三行显示省略号 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    }
    .ch-gw-feature-desc-newline{
      padding-top: 0.5rem;
      height: 4.5em;
      line-height: 1.4em;
      overflow: hidden;
      width: 95%;
      margin: 0 auto;
      /* 三行显示省略号 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
    .ch-gw-pricing{
      padding-top:80px;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
    .product-img:hover{
      transform: scale(1.1);
    }
    .product-img{
      transition: transform 0.5s ease;
    }
    
</style>




// WEBPACK FOOTER //
// src/components/index.vue